import { render } from "./serviceAgreement.vue?vue&type=template&id=5d26eee6&scoped=true"
import script from "./serviceAgreement.vue?vue&type=script&lang=js"
export * from "./serviceAgreement.vue?vue&type=script&lang=js"

import "./serviceAgreement.vue?vue&type=style&index=0&id=5d26eee6&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d26eee6"]])

export default __exports__